import {Component, inject} from '@angular/core';
import {TripCardComponent} from '../trip-card/trip-card.component';
import {TopBarComponent} from '../top-bar/top-bar.component';
import {MirandaApiService} from '../../services/miranda-api.service';
import {AsyncPipe} from '@angular/common';
import {SessionStorageService} from 'ngx-webstorage';
import {DriverReq, DriverReqsParams, PassengerReqsParams, PassengerRequest} from '../../interfaces/miranda.interface';
import moment from 'moment';
import {BehaviorSubject, tap} from 'rxjs';
import {InfiniteScrollDirective} from 'ngx-infinite-scroll';
import {ProgressSpinnerComponent} from '../progress-spinner/progress-spinner.component';
import {Router} from '@angular/router';
import {MatProgressSpinner} from '@angular/material/progress-spinner';

@Component({
  selector: 'app-trip-list',
  imports: [
    TripCardComponent,
    TopBarComponent,
    AsyncPipe,
    InfiniteScrollDirective,
    ProgressSpinnerComponent,
    MatProgressSpinner,
  ],
  templateUrl: './trip-list.component.html',
  styleUrl: './trip-list.component.scss'
})
export class TripListComponent {

  private sessionStorageService: SessionStorageService = inject(SessionStorageService);
  private mirandaApiService: MirandaApiService = inject(MirandaApiService);
  private router: Router = inject(Router);
  private driverReqParams: DriverReqsParams = {
    start_date: moment().subtract(50, 'days').format('YYYY-MM-DD HH:mm:ss'),
    finish_date: moment().add(50, 'days').format('YYYY-MM-DD HH:mm:ss'),
    offset: 0,
    limit: 20
  }
  private driverReqTotal = 0;
  public driverRequests$: BehaviorSubject<DriverReq[]> = new BehaviorSubject<DriverReq[]>([]);
  private passengerReqParams: PassengerReqsParams = {
    service_id: this.sessionStorageService.retrieve('service'),
    page: 1,
    per_page: 20
  }
  private passengerLastPage: number = 0;
  public passengerRequests$: BehaviorSubject<PassengerRequest[]> = new BehaviorSubject<PassengerRequest[]>([]);
  public userType = this.sessionStorageService.retrieve('userType');
  public driverReq$ = this.mirandaApiService.getDriverReq(this.driverReqParams).pipe(
    tap((resp) => {
      this.driverReqTotal = resp.total;
      this.driverRequests$.next([...this.driverRequests$.value, ...resp.data]);
    })
  );
  public passengerReq$ = this.mirandaApiService.getPassengerReq(this.passengerReqParams).pipe(
    tap((resp) => {
      this.passengerLastPage = resp.meta.last_page;
      this.passengerRequests$.next([...this.passengerRequests$.value, ...resp.data]);
    })
  );



  public onScroll() {
    if(this.userType === 'passenger') {
      if(this.passengerReqParams.page < this.passengerLastPage) {
        this.passengerReqParams.page += 1;
        this.passengerReq$ = this.mirandaApiService.getPassengerReq(this.passengerReqParams).pipe(
          tap((resp) => {
            this.passengerLastPage = resp.meta.last_page;
            this.passengerRequests$.next([...this.passengerRequests$.value, ...resp.data]);
          })
        );
      }
    } else if (this.userType === 'driver') {
      if(this.driverRequests$.value.length < this.driverReqTotal) {
        this.driverReqParams.offset += 20;
        this.driverReq$ = this.mirandaApiService.getDriverReq(this.driverReqParams).pipe(
          tap((resp) => {
            this.driverRequests$.next([...this.driverRequests$.value, ...resp.data]);
          })
        );
      }
    }
  }

  onTripClick(trip: DriverReq | PassengerRequest, userType: any) {
    this.sessionStorageService.store('trip', trip);
      this.router.navigate([`/trip-details`]);
  }
}
